import React, { useEffect, useState } from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

export default function UsersTierReport() {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const [filterData, setFilterData] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);

    useEffect(() => {
        getReportData(
            {
                mobile: "",
                status: "",
                startDate: "",
                endDate: "",
            },
            1
        );
    }, []);

    const searchFormik = useFormik({
        initialValues: {
            mobile: "",
            status: "",
            startDate: "",
            endDate: "",
        },
        validate: (data) => {
            let errors = {};

            if (data.startDate && !data.endDate) {
                errors.endDate = "End date is required when start date is selected";
            }

            if (data.mobile && data.mobile.length < 10) {
                errors.mobile = "Mobile must be in 10 digits.";
            }

            if (data.startDate && data.endDate && data.startDate > data.endDate) {
                errors.endDate = "End date should be greater than start date";
            }

            return errors;
        },
        onSubmit: (data) => {
            setCurrentPage(1);
            getReportData(data, 1);
            setFilterData(data);
        },
    });

    const isSearchFormFieldValid = (name) =>
        !!(searchFormik.touched[name] && searchFormik.errors[name]);

    const getSearchFormErrorMessage = (name) =>
        isSearchFormFieldValid(name) && (
            <small className="report-error-field">
                {searchFormik.errors[name]}
            </small>
        );

    const getReportData = async (data, pageNum) => {
        setLoading(true);
        if (!token) {
            navigate("/");
            return;
        }

        const searchMobile =
            data?.mobile !== undefined && data?.mobile !== ""
                ? `&mobile=${data?.mobile}`
                : "";
        const searchStatus =
            data?.status !== undefined && data?.status !== ""
                ? `&status=${data?.status}`
                : "";

        let stDate = "";
        let endDate = "";

        if (data?.startDate && data?.endDate) {
            const startFormattedDate = moment(data.startDate).format(
                "YYYY-MM-DD HH:mm:ss"
            );
            const endFormattedDate = moment(data.endDate).format(
                "YYYY-MM-DD 23:59:59"
            );

            stDate = `&start=${startFormattedDate}`;
            endDate = `&end=${endFormattedDate}`;
        }

        await axios
            .get(
                Constants.baseUrl +
                `reports/usersTier/list?${searchMobile}${searchStatus}${stDate}${endDate}&sortBy=createDateTime&userType=MEMBER&sortAsc=true&limit=${limit}&page=${pageNum}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Accept-Language": localStorage.getItem("langauge"),
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        company: Constants.company,
                        program: Constants.program,
                    },
                }
            )
            .then((res) => {
                const dt = res.data;
                if (dt.result === "success") {
                    setReportData(dt?.output?.results);
                    setTotalPages(dt?.output?.totalPages);
                    setLoading(false);
                }
                if (dt.result === "error" || dt.result === "dialog") {
                    setReportData(null);
                    setTotalPages(0);
                    setLoading(false);
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const download = (data) => {
        setLoading(true);
        setDownloadLoading(true);

        try {
            const searchMobile = data.mobile === "" ? "" : `&mobile=${data.mobile}`;
            const searchStatus = data.status === "" ? "" : `&status=${data.status}`;
            let stDate = "";
            let endDate = "";

            if (data.startDate && data.endDate) {
                const startFormattedDate = moment(data.startDate).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                const endFormattedDate = moment(data.endDate).format(
                    "YYYY-MM-DD 23:59:59"
                );
                stDate = `&start=${startFormattedDate}`;
                endDate = `&end=${endFormattedDate}`;
            }

            axios
                .get(
                    Constants.baseUrl +
                    `reports/download/UsersTier?${searchMobile}${searchStatus}${stDate}${endDate}&userType=MEMBER`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language": localStorage.getItem("langauge"),
                            appVersion: Constants.av,
                            platform: Constants.pt,
                            company: Constants.company,
                            program: Constants.program,
                        },
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        const fileData = new Blob([res.data], { type: "text/csv" });
                        saveAs(fileData, "users_tier_report.csv");
                        setDownloadLoading(false);
                    } else {
                        swal({
                            text: res.data.msg,
                            timer: 2000,
                            buttons: false,
                        });
                        setDownloadLoading(false);
                    }
                });
        } catch (error) {
            console.log(error);
            setDownloadLoading(false);
        }
    };

    return (
        <>
            {loading ? <Oval /> : null}
            <Navbar />
            <section className="page-content--bge55">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="head1">UsersTier Report</h3>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={searchFormik.handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control reset"
                                                        type="text"
                                                        placeholder="Mobile No."
                                                        id="mobile"
                                                        value={searchFormik.values.mobile}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value
                                                                .replace(/\D/g, "")
                                                                .slice(0, 10);
                                                            searchFormik.handleChange({
                                                                target: {
                                                                    name: "mobile",
                                                                    value: numericValue,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {getSearchFormErrorMessage("mobile")}
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <DatePicker
                                                    id="startDate"
                                                    selected={searchFormik.values.startDate}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("startDate", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    maxDate={new Date()}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onFocus={(e) => e.target.blur()}
                                                    onClick={(e) => e.preventDefault()}
                                                    placeholderText="From date *"
                                                />
                                                {getSearchFormErrorMessage("startDate")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <DatePicker
                                                    id="endDate"
                                                    selected={searchFormik.values.endDate}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("endDate", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    minDate={searchFormik.values.startDate || null}
                                                    maxDate={
                                                        searchFormik.values.startDate
                                                            ? moment(searchFormik.values.startDate)
                                                                .add(30, "days")
                                                                .toDate()
                                                            : new Date()
                                                    }
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onFocus={(e) => e.target.blur()}
                                                    onClick={(e) => e.preventDefault()}
                                                    placeholderText="To date *"
                                                />
                                                {getSearchFormErrorMessage("endDate")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <select
                                                    className="form-control"
                                                    id="status"
                                                    value={searchFormik.values.status}
                                                    onChange={searchFormik.handleChange}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="APPROVED">APPROVED</option>
                                                    <option value="VERIFIED">VERIFIED</option>
                                                    {/* <option value="BLOCKED">Blocked</option> */}
                                                </select>
                                                {getSearchFormErrorMessage("status")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                        <div className="d-flex justify-content-between">
                                            <button
                                                type="submit"
                                                className="btn btn-primary report-submit-button"
                                            >
                                                Search
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary report-submit-button"
                                                onClick={() => {
                                                    setFilterData({});
                                                    setCurrentPage(1);
                                                    searchFormik.resetForm();
                                                    getReportData(
                                                        {
                                                            mobile: "",
                                                            status: "",
                                                            startDate: "",
                                                            endDate: "",
                                                        },
                                                        1
                                                    );
                                                }}
                                            >
                                                Reset
                                            </button>

                                            {reportData === null ? (
                                                ""
                                            ) : (
                                                <Link
                                                    to="#"
                                                    className={`btn btn-primary report-submit-button mx-5 ${downloadLoading ? "btn-opacity" : ""
                                                        }`}
                                                    onClick={() => download(searchFormik.values)}
                                                >
                                                    {downloadLoading ? (
                                                        <span>
                                                            <i className="fa fa-spinner fa-spin"></i>Export
                                                        </span>
                                                    ) : (
                                                        " Export"
                                                    )}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="row mt-20">
                                <div className="col-md-12">
                                    <div className="table-responsive table--no-card">
                                        <table className="table table-borderless table-striped table-earning">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>UserID</th>
                                                    <th>Plumber Name</th>
                                                    <th>Plumber Mobile</th>
                                                    <th>User Branch</th>
                                                    <th>User Zone</th>
                                                    <th>Plumber Email</th>
                                                    <th>FS Mobile</th>
                                                    <th>FS Code</th>
                                                    <th>FS Name</th>
                                                    <th>TerritoryCode</th>
                                                    <th>TerritoryName</th>
                                                    <th>Member Profile</th>
                                                    <th>User Status</th>
                                                    <th>Current Tier</th>
                                                    <th>Tier Bonus Percentage</th>
                                                    <th>Given Tier Bonus</th>
                                                    <th>Base Point 2627</th>
                                                    <th>Total Points</th>
                                                </tr>
                                            </thead>
                                            {reportData === null ? (
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            colSpan="19"
                                                            style={{ textAlign: "center", fontSize: "16px" }}
                                                        >
                                                            No record found!
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    {reportData &&
                                                        reportData.map((item, index) => {
                                                            const serialNumber =
                                                                (currentPage - 1) * limit + index + 1;
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{serialNumber}</td>
                                                                    <td>{item[0]}</td>
                                                                    <td>{item[1]}</td>
                                                                    <td>{item[2]}</td>
                                                                    <td>{item[3]}</td>
                                                                    <td>{item[4]}</td>
                                                                    <td>{item[5]}</td>
                                                                    <td>{item[6]}</td>
                                                                    <td>{item[7]}</td>
                                                                    <td>{item[8]}</td>
                                                                    <td>{item[9]}</td>
                                                                    <td>{item[10]}</td>
                                                                    <td>{item[11]}</td>
                                                                    <td>{item[12]}</td>
                                                                    <td>{item[13]}</td>
                                                                    <td>{item[14]}</td>
                                                                    <td>{item[15]}</td>
                                                                    <td>{item[16]}</td>
                                                                    <td>{item[17]}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            )}
                                        </table>
                                        {totalPages > 1 && (
                                            <ResponsivePagination
                                                current={currentPage}
                                                total={totalPages}
                                                onPageChange={(page) => {
                                                    setCurrentPage(page);
                                                    getReportData(filterData, page);
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
